// @core/api/endpoints/document/get_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get pipeline
 * Returns a pipeline template with all stages.
 */
export async function GetPipeline(
  pipeline_id: string,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-pipelines/:pipeline_id`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<PipelineResponse>(requestPath, { ...requestOptions });
}
